import React from 'react';
import { Helmet } from 'react-helmet-async';

interface LocalBusinessProps {
  type?: 'LocalBusiness';
}

interface ProductProps {
  type?: 'Product';
  name: string;
  description: string;
  image?: string;
  price?: number;
  priceCurrency?: string;
}

type StructuredDataProps = LocalBusinessProps | ProductProps;

const StructuredData: React.FC<StructuredDataProps> = (props) => {
  let structuredData: any;

  if (props.type === 'Product') {
    const productProps = props as ProductProps;
    structuredData = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: productProps.name,
      description: productProps.description,
      image: productProps.image,
      offers: productProps.price ? {
        '@type': 'Offer',
        price: productProps.price,
        priceCurrency: productProps.priceCurrency || 'USD',
        availability: 'https://schema.org/InStock'
      } : undefined
    };
  } else {
    // LocalBusiness schema (default)
    structuredData = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      '@id': 'https://keystoneprinter.com',
      name: 'Keystone Sign Printing',
      description: 'Professional sign and brand printing services. High-quality banners, signs, decals, displays, and stickers for your business.',
      url: 'https://keystoneprinter.com',
      telephone: '+12677183596',
      email: 'info@keystoneprinter.com',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '24 Green Street',
        addressLocality: 'Lansdale',
        addressRegion: 'PA',
        postalCode: '19446',
        addressCountry: 'US'
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 40.2415,
        longitude: -75.2838
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '08:00',
          closes: '17:00'
        }
      ],
      priceRange: '$$',
      image: [
        'https://keystoneprinter.com/logos/logo.svg'
      ],
      sameAs: []
    };
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default StructuredData;